import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { fromTypeCode: string; description: string; display: boolean; emailAddress: string | null; deleted: boolean; }
const schema = z.object({
  fromTypeCode: z.string().min(1).max(20),
  description: z.string().min(1).max(100),
  display: z.boolean(),
  emailAddress: z.string().email().or(z.literal("")).nullable().optional(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function FromEmailTypesPage() {
  return <LookupListPage<Row, Form>
    title="From-email types"
    apiPath="/api/lookups/from-email-types"
    schema={schema}
    rowKey={(r) => r.fromTypeCode}
    columns={[
      { id: "code",  header: "Code", accessor: (r) => r.fromTypeCode },
      { id: "desc",  header: "Description", accessor: (r) => r.description },
      { id: "disp",  header: "Display", accessor: (r) => r.display ? "Yes" : "—" },
      { id: "email", header: "Email address", accessor: (r) => r.emailAddress ?? "—" },
    ]}
    toFormValues={(r) => ({ fromTypeCode: r.fromTypeCode, description: r.description, display: r.display, emailAddress: r.emailAddress ?? "", deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ fromTypeCode: "", description: "", display: false, emailAddress: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("fromTypeCode")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <label className="flex items-center gap-2"><input type="checkbox" {...f.register("display")} /> Display</label>
        <div><Label htmlFor="e">Email address</Label><Input id="e" type="email" {...f.register("emailAddress")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
